/** Clinic Details */

'use strict'

$(document).ready(function () {
  // Facilities Carousel - Slick Initialization
  $('#facilities-long-carousel').slick({
    centerMode: false,
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    prevArrow: $('.slick__prev--facilities'),
    nextArrow: $('.slick__next--facilities'),
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerMode: false,
          dots: false,
          arrows: true,
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          centerMode: false,
          dots: false,
          arrows: true,
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          dots: false,
          arrows: true,
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          dots: false,
          arrows: true,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('#facilities-main-carousel').slick({
    centerMode: false,
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,    
    prevArrow: $('.slick__prev--facilities'),    
    nextArrow: $('.slick__next--facilities'),    
    adaptiveHeight: true,
  });
});